module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0105.jpg?v=f4a413d3";